import { useMemo } from "react"
import useFilePathContext from "utils/files/useFilePathContext"
import { File, Options } from "utils/files/types"

export default function useFilePath(file?: File | null, size?: Options) {
  const getFilePath = useFilePathContext()

  return useMemo(() => {
    if (!file) return null
    return getFilePath(file, size, false)
  }, [file, getFilePath, size])
}
